import { Route, Routes } from "react-router-dom";
import { Suspense } from "react";
import Login from "../login/Login";
import HomePage from "../home/HomePage";
import TemporaryTrafficChangeForm from "../entries/TemporaryTrafficChangeForm";
import PermanentTrafficChangeForm from "../entries/PermanentTrafficChangeForm";
import CompletedEntries from "../entries/CompletedEntries";
import SubmittedEntries from "../entries/SubmittedEntries";
import NewEntry from "../entries/NewEntry";
import EntryDetailedView from "../entries/EntryDetailedView";
import Registration from "../login/Registration";
import ConfirmRegistration from "../login/ConfirmRegistration";
import { Verification } from "../verification/Verification";

export default function AppRoutes() {
  return (
    <Routes>
      <Route
        path="/"
        element={
          <Suspense fallback={<></>}>
            <HomePage />
          </Suspense>
        }
      />
      <Route
        path="/entries/new"
        element={
          <Suspense fallback={<></>}>
            <NewEntry />
          </Suspense>
        }
      />
      <Route
        path="/entries/details/:id"
        element={
          <Suspense fallback={<></>}>
            <EntryDetailedView />
          </Suspense>
        }
      />
      <Route
        path="/entries/submitted"
        element={
          <Suspense fallback={<></>}>
            <SubmittedEntries />
          </Suspense>
        }
      />
      <Route
        path="/entries/completed"
        element={
          <Suspense fallback={<></>}>
            <CompletedEntries />
          </Suspense>
        }
      />
      <Route
        path="/entries/new/temporary-change"
        element={
          <Suspense fallback={<></>}>
            <TemporaryTrafficChangeForm />
          </Suspense>
        }
      />
      <Route
        path="/entries/new/permanent-change"
        element={
          <Suspense fallback={<></>}>
            <PermanentTrafficChangeForm />
          </Suspense>
        }
      />
      <Route
        path="/login"
        element={
          <Suspense fallback={<></>}>
            <Login />
          </Suspense>
        }
      />
      <Route
        path="/registration"
        element={
          <Suspense fallback={<></>}>
            <Registration />
          </Suspense>
        }
      />
      <Route
        path="/registration/confirm/:token"
        element={
          <Suspense fallback={<></>}>
            <ConfirmRegistration />
          </Suspense>
        }
      />
      <Route
        path="/verification/:appEntryId"
        element={
          <Suspense fallback={<></>}>
            <Verification />
          </Suspense>
        }
      />
    </Routes>
  );
}
